export function FolderSharedIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M3 6a3 3 0 013-3h3a3 3 0 012.4 1.2L13.5 7H18a3 3 0 013 3v3.682A6 6 0 0111.528 21H6a3 3 0 01-3-3V6zm7.341 13A6 6 0 0119 11.803V10a1 1 0 00-1-1H5v9a1 1 0 001 1h4.341zM9.8 5.4A1 1 0 009 5H6a1 1 0 00-1 1v1h6L9.8 5.4zm9.2 9.1a1.5 1.5 0 10-2.932.449l-1.737 1.302a1.5 1.5 0 10.21 2.328l1.47.736a1.5 1.5 0 10.447-.894l-1.47-.736a1.531 1.531 0 00-.056-.634l1.737-1.302A1.5 1.5 0 0019 14.5z"
      ></path>
    </svg>
  );
}
